// extracted by mini-css-extract-plugin
export default {"logo":"Login_logo__W+opJ"};